export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/3Dwn9m3moLwBrkayXRqzTi/ENERGIE_IT_PAGINA_1.jpg',
    alt: 'Copertina del Volume 1, Fondamenti delle Energie Rinnovabili: energia, conversione e sistemi, con pannelli solari, turbine eoliche e una diga',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/gvfQUKtMZNBs5XuGar3D31/ENERGIE_IT_PAGINA_2.jpg',
    alt: 'Pagina di esempio Sei grandi famiglie di fonti rinnovabili: mappa di solare, eolica, idroelettrica, biomassa, geotermica ed energia dal mare',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/t5ou5mbm36uDUfzmEBw1z8/ENERGIE_IT_PAGINA_3.jpg',
    alt: 'Pagina di esempio La potenza del vento cresce con il cubo della velocità, con anatomia della turbina e formula della potenza eolica',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/ad34ebkA4AYZbtXjibmnn4/ENERGIE_IT_PAGINA_4.jpg',
    alt: "Pagina di esempio Conservare l'energia per usarla dopo: batterie, pompaggio idroelettrico, accumulo termico e idrogeno",
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/67zXxvzN6ML29aEKE3L3Hk/ENERGIE_IT_PAGINA_5.jpg',
    alt: 'Pagina di esempio Fondamenti delle energie rinnovabili, scheda di campo con fonte, conversione, formule e attività in classe',
  },
];
